<!--
  ~ Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
  ~
  ~ Please see distribution for license.
  -->
<mat-horizontal-stepper [linear]="true">
  <mat-step [stepControl]="coreTenantDetails">
    <ng-template matStepLabel>Enter tenant details</ng-template>
    <og-tenant-setup
      [tenantDetailsFormGroup]="coreTenantDetails"
      (nameChange)="onTenantNameChange($event)"
      (organizationIdChange)="onTenantOrganizationIdChange($event)"
      (tenantDetailsChange)="tenantDetails = $event"
      (formSubmission)="onFormSubmitted()"
      (cancelClick)="onWizardCancelled()"
    ></og-tenant-setup>
    @if (tenantCreationInProgress$ | async) {
    <div class="spinner">
      <mat-progress-spinner [mode]="'indeterminate'" [color]="'primary'"></mat-progress-spinner>
    </div>
    }
  </mat-step>
</mat-horizontal-stepper>
